import { lazy } from 'react';
import paths from '../paths';
import { createRoute } from 'constants/utils';

const Campaigns = lazy(() => import('../../components/pages/campaign/campaigns/Campaigns'));
const CampaignSettings = lazy(() => import('../../components/pages/campaign/campaignSettings/CampaignSettings'));

export const campaignRoutes = (abilities) => {
  return [
    (abilities?.campaign?.read ?? false) && createRoute(paths.campaigns, Campaigns),
    (abilities?.category?.read ?? false) && createRoute(paths.campaignSettings, CampaignSettings),
  ];
};
